import styled from 'styled-components';
import TableCell from '@material-ui/core/TableCell';

export const DenseCell = styled(TableCell)`
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
